export const onPlayClick = async ({ publicationViewed, userId, mediaId }) => {
  const result = await publicationViewed({
    variables: {
      contentId: mediaId,
      contentType: 'media',
      userId,
    },
  });

  if (result?.data?.PublicationViewedResultSuccessType) {
    return;
  }

  if (result?.data?.PublicationViewedResultErrorType) {
    // eslint-disable-next-line
    console.warn(
      'Something with wrong with registering that a video is being played/viewed by a user'
    );
  }
};
